import { CartCostTypeEnum } from '@onArte/shared/database/enums';

export class OrderCostInfoDTO {
  constructor(
    public auctionId: string,
    public type: CartCostTypeEnum,
    public basePrice: number,
    public finalPrice: number
  ) {}
}
